import {mapEnumValueToEnumKey, mapStringToEnumValue, throwIfUndefined} from '@coolcolduk/util';
import {TradeDirection, TradeStatus, TradeWrite} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeDocRef} from './getTradeDocRef';

export async function updateTrade(
  id: string,
  input: Partial<Omit<TradeWrite, 'tradeId' | 'createdAt' | 'message'>>,
): Promise<void> {
  const uid = await getCurrentUserIdValidated();
  const ref = getTradeDocRef(uid, id);

  const resolved: Partial<Omit<TradeWrite, 'tradeId' | 'createdAt' | 'message'>> = {...input};

  if (input.direction != null) {
    const directionKey = mapEnumValueToEnumKey(TradeDirection, input.direction);
    resolved.direction =
      directionKey != null
        ? TradeDirection[directionKey as keyof typeof TradeDirection]
        : throwIfUndefined(mapStringToEnumValue(TradeDirection, input.direction), 'Invalid trade direction');
  }

  if (input.status != null) {
    const statusKey = mapEnumValueToEnumKey(TradeStatus, input.status);
    resolved.status =
      statusKey != null
        ? TradeStatus[statusKey as keyof typeof TradeStatus]
        : throwIfUndefined(mapStringToEnumValue(TradeStatus, input.status), 'Invalid trade status');
  }

  await updateDoc(ref, resolved);
}
